import { useRef } from 'react'
import { useVirtualizer } from '@tanstack/react-virtual'

type UseVirtualOptions = {
  count: number
  estimateSize?: number
  overscan?: number
}

export function useVirtual({ count, estimateSize = 30, overscan = 8 }: UseVirtualOptions) {
  const parentRef = useRef<HTMLDivElement>(null)

  const virtualizer = useVirtualizer({
    count,
    getScrollElement: () => parentRef.current,
    estimateSize: () => estimateSize,
    overscan,
  })

  return {
    parentRef,
    virtualizer,
    virtualItems: virtualizer.getVirtualItems(),
    totalSize: virtualizer.getTotalSize(),
  }
}
